module.exports = __webpack_public_path__ + "img/jpg4_zixunliebiao.89e5d320.png";